import React, { Fragment, MouseEvent, useState } from 'react';
import { IMenu } from './interfaces';
import { IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { ContextMenu, ContextMenuOption } from '@components/context-menu';
import DeleteIcon from '@mui/icons-material/Delete';
import FlagIcon from '@mui/icons-material/Flag';
import { useTranslation } from 'react-i18next';
import { DeleteCommentDialog } from '@components/feed/dialogs/DeleteCommentDialog';

export const Menu: React.FC<IMenu> = ({
  messageId,
  commentId,
  currentUserIsAuthor,
}): JSX.Element => {
  const { t } = useTranslation();
  const [showDeleteDialog, setShowDeleteDialog] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = () => {
    handleMenuClose();
    setShowDeleteDialog(true);
  };

  return (
    <Fragment>
      <IconButton
        className="hover-actions"
        aria-label="settings"
        size="small"
        onClick={handleMenuOpen}
        sx={{
          opacity: 0,
          visibility: 'hidden',
        }}
      >
        <MoreVertIcon
          sx={{
            width: '15px',
            height: '15px',
          }}
        />
      </IconButton>
      <ContextMenu
        anchorEl={anchorEl}
        open={anchorEl !== null}
        onClose={handleMenuClose}
      >
        {currentUserIsAuthor ? (
          <ContextMenuOption
            onClick={handleDelete}
            label={t('feed:buttons.deleteComment')}
            icon={DeleteIcon}
          />
        ) : (
          <ContextMenuOption
            onClick={() => console.log('report comment')}
            label={t('feed:buttons.reportComment')}
            icon={FlagIcon}
          />
        )}
      </ContextMenu>

      <DeleteCommentDialog
        messageId={messageId}
        commentId={commentId}
        show={showDeleteDialog}
        onClose={() => setShowDeleteDialog(false)}
      />
    </Fragment>
  );
};
